<dx-popup [(visible)]="visible" (visibleChange)="visibleChange.emit($event)" [showTitle]="false" [width]="'calc(100vw - 32px)'" [maxWidth]="1180" [height]="'calc(100vh - 32px)'" [maxHeight]="760" [dragEnabled]="false" [hideOnOutsideClick]="false" [showCloseButton]="false">

	<div *dxTemplate="let data of 'content'">
		<div class="expression-editor" data-cy="mapper-expression-editor">
			<header class="expression-header">
				<div>
					<div class="expression-kicker">Expression builder</div>
					<h2>Expression editor</h2>
					<p>Build and test the value for <strong>{{ getEditingFieldTitle() }}</strong>.</p>
				</div>
				<button type="button" class="close-button" aria-label="Close expression editor" (click)="cancel.emit()">&times;</button>
			</header>

			<div class="expression-body structured-popup" [class.has-left-panel]="selectedSourceField?.isPicklist">
			<div class="popup-left left-panel" *ngIf="selectedSourceField?.isPicklist">
				<div class="helper-title">Picklist Values</div>

				<div class="small-muted left-panel-helper">
					Use these values for <code>[{{ selectedSourceField?.path }}]</code> without guessing raw keys.
				</div>

				<div class="left-panel-count" *ngIf="selectedFieldPicklistOptions.length">
					<span class="chip picklist">{{ selectedFieldPicklistOptions.length }} options</span>
				</div>

				<div class="picklist-option-list left-panel-list" *ngIf="selectedFieldPicklistOptions.length; else noSelectedPicklistOptions">
					<div class="picklist-option-card left-panel-card" *ngFor="let option of selectedFieldPicklistOptions">
						<div class="picklist-option-copy">
							<div class="picklist-option-label">{{ option.label }}</div>
							<div class="picklist-option-value">Value: <code>{{ option.value }}</code></div>
						</div>

						<div class="picklist-option-actions left-panel-actions">
							<button type="button" class="example-chip" (click)="insertPicklistValue.emit(option)">Insert value</button>
							<button type="button" class="example-chip" (click)="insertPicklistComparison.emit(option)">Insert comparison</button>
						</div>
					</div>
				</div>

				<ng-template #noSelectedPicklistOptions>
					<div class="empty-hint">No active picklist options were loaded for this field.</div>
				</ng-template>
			</div>

			<div class="popup-main">
				<div class="editing-field-card" *ngIf="editingRow">
					<div class="editing-field-copy">
						<div class="editing-field-label">Editing field</div>
						<div class="editing-field-title-row">
							<div>
								<div class="editing-field-title">{{ getEditingFieldTitle() }}</div>
								<div class="editing-field-path" *ngIf="getEditingFieldPath() as fieldPath">{{ fieldPath }}</div>
							</div>

							<div class="editing-field-info" tabindex="0" role="button" aria-label="Show edited field details">
								<span class="editing-field-info-icon">i</span>
								<div class="editing-field-popover">
									<div class="editing-field-popover-title">{{ getEditingFieldTitle() }}</div>
									<div class="editing-field-popover-copy">{{ getEditingFieldDescription() }}</div>
									<div class="editing-field-popover-detail" *ngIf="getEditingFieldDetails()">{{ getEditingFieldDetails() }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="section-header">
					<div class="helper-title">Expression</div>

					<button type="button" class="tips-trigger" (click)="toggleTips()" [attr.aria-expanded]="tipsExpanded" title="Show expression tips">
            <span class="tips-trigger-icon">?</span>
            <span class="tips-trigger-text">Tips</span>
          </button>
				</div>

				<div class="expression-editor-wrap">
					<dx-text-area [(value)]="draft" (valueChange)="draftChange.emit($event)" [height]="120" [elementAttr]="expressionDraftElementAttr" placeholder="Example: Iif(IsNull([Account.Owner.Email]), [Account.Email], Lower([Account.Owner.Email]))" (onInitialized)="editorInitialized.emit($event)" (onInput)="editorInput.emit()"
						(onFocusIn)="editorFocusIn.emit()" (onKeyDown)="editorKeyDown.emit($event)">
					</dx-text-area>

					<div class="expression-autocomplete" *ngIf="expressionSuggestionsVisible">
						<div class="expression-autocomplete-item" [class.active]="i === expressionSuggestionIndex" *ngFor="let item of expressionSuggestions; let i = index" (mousedown)="$event.preventDefault()" (click)="applySuggestion.emit(item)">
							<div class="expression-autocomplete-path">{{ item.label }}</div>
							<div class="expression-autocomplete-label">{{ item.subLabel }}</div>
						</div>
					</div>
				</div>

				<div class="expression-test-panel">
					<div class="expression-test-actions">
						<button type="button" class="example-chip expression-test-button" [disabled]="!canTestExpression || expressionTestLoading" (click)="testExpression.emit()">
							{{ expressionTestLoading ? 'Testing...' : 'Test expression' }}
						</button>

						<span class="expression-test-status" *ngIf="expressionTestRan && !expressionTestLoading" [class.is-valid]="expressionTestHasResult || expressionTestIsValid === true" [class.is-invalid]="!expressionTestHasResult && expressionTestIsValid === false">
							{{ expressionTestHasResult ? 'Evaluated' : expressionTestIsValid === false ? 'Issue' : 'Expression OK' }}
						</span>
					</div>

					<div class="expression-test-result" *ngIf="expressionTestRan || expressionTestLoading">
						<div class="expression-test-message" *ngIf="expressionTestMessage">{{ expressionTestMessage }}</div>

						<div class="expression-test-output" *ngIf="!expressionTestLoading && expressionTestHasResult">
							<span>Output</span>
							<code>{{ formatExpressionTestResult(expressionTestResult) }}</code>
						</div>

						<div class="expression-test-used-values" *ngIf="expressionTestUsedValues.length">
							<div class="expression-test-used-title">Used field values</div>

							<div class="expression-test-used-row" *ngFor="let item of expressionTestUsedValues">
								<div>
									<div class="expression-test-used-label">{{ item.label }}</div>
									<div class="expression-test-used-path">[{{ item.path }}]</div>
								</div>

								<code>{{ item.value }}</code>
							</div>
						</div>
					</div>
				</div>

				<div class="popup-main-scroll">
					<div class="tips-panel" *ngIf="tipsExpanded">
						<div class="tips-panel-header">Tips for expressions</div>

						<div class="tips-list">
							<div class="tip-row">
								Click a field in the tree to insert a path like <code>[billToCountryID.Name]</code>.
							</div>
							<div class="tip-row">
								Use <code>+</code> to combine text values.
							</div>
							<div class="tip-row">
								Keep spaces and separators with string literals like <code>' '</code>, <code>', '</code>, or <code>' - '</code>.
							</div>
							<div class="tip-row">
								Use <code>Upper()</code>, <code>Lower()</code>, <code>Trim()</code>, <code>Iif()</code>, and <code>IsNull()</code>.
							</div>
						</div>

						<div class="tips-examples">
							<button type="button" class="example-chip" (click)="onExampleClick(exampleJoinWithSpace)">
        Join two values with a space
      </button>

							<button type="button" class="example-chip" (click)="onExampleClick(exampleAddSeparator)">
        Add a separator
      </button>

							<button type="button" class="example-chip" (click)="onExampleClick(exampleFallbackValue)">
        Fallback value
      </button>

							<button type="button" class="example-chip" (click)="onExampleClick(exampleWrapInParentheses)">
        Wrap in parentheses
      </button>
						</div>
					</div>

					<div class="expression-field-tabs section-gap" *ngIf="showTargetFields; else sourceFieldsTitle">
						<button type="button" class="expression-field-tab" [class.active]="expressionFieldTab === 'source'" (click)="setExpressionFieldTab('source')">{{ sourceSystemName }} Fields</button>
						<button type="button" class="expression-field-tab" [class.active]="expressionFieldTab === 'target'" (click)="setExpressionFieldTab('target')">{{ targetSystemName }} Result Fields</button>
					</div>

					<ng-template #sourceFieldsTitle>
						<div class="helper-title section-gap">{{ sourceSystemName }} Fields</div>
					</ng-template>

					<div *ngIf="expressionFieldTab === 'source'">
						<input class="grid-search" data-cy="mapper-expression-source-search" type="text" [value]="fieldSearch" (input)="fieldSearchChange.emit($any($event.target).value)" placeholder="Search {{ sourceSystemName }} fields by name or path..." />

						<div class="small-muted tree-hint">
							Browse the tree and click a field to insert it into the expression as <code>[fieldPath]</code>.
						</div>

						<div class="expression-tree-wrap">
							<dx-tree-view [items]="sourceTreeItems" dataStructure="tree" keyExpr="id" displayExpr="displayName" itemsExpr="items" hasItemsExpr="hasItems" [searchEnabled]="false" [expandEvent]="'click'" [selectByClick]="true" [focusStateEnabled]="false" [activeStateEnabled]="true" (onItemClick)="treeFieldSelected.emit($event?.itemData)" (onItemExpanded)="deferredSourceNodeExpanded.emit($event?.itemData)">

								<div *dxTemplate="let item of 'item'">
									<div class="tree-item" [attr.data-cy]="'mapper-expression-source-field-' + item.path" (click)="onSourceTreeItemClick($event, item)">
										<div class="tree-leading">
											<div class="tree-main">
												<span class="tree-name">{{ item.displayName }}</span>
												<span class="tree-path" *ngIf="item.path">{{ item.path }}</span>
											</div>
										</div>

										<div class="chips">
											<span class="chip type" *ngIf="item.dataType">{{ item.dataType }}</span>
											<span class="chip readonly" *ngIf="item.isReadOnly">readonly</span>
											<button type="button" class="chip picklist picklist-chip-button" *ngIf="item.isPicklist" title="Show picklist values" (mousedown)="$event.preventDefault(); $event.stopPropagation()" (click)="onPicklistChipClick($event, item)">picklist</button>
											<span class="chip reference" *ngIf="item.isReference">reference</span>
											<span class="chip udf" *ngIf="item.isUserDefinedField">UDF</span>
											<span class="chip" *ngIf="item.isCollection">collection</span>
										</div>
									</div>
								</div>
							</dx-tree-view>
						</div>
					</div>

					<div *ngIf="showTargetFields && expressionFieldTab === 'target'">
						<input class="grid-search" type="text" [value]="targetFieldSearch" (input)="targetFieldSearchChange.emit($any($event.target).value)" placeholder="Search returned {{ targetSystemName }} fields by name or path..." />

						<div class="small-muted tree-hint">
							Click a returned {{ targetSystemName }} field to insert it as <code>Result.fieldPath</code> for writeback expressions.
						</div>

						<div class="expression-tree-wrap">
							<dx-tree-view [items]="targetTreeItems" dataStructure="tree" keyExpr="id" displayExpr="displayName" itemsExpr="items" [searchEnabled]="false" [expandEvent]="'click'" [selectByClick]="true" [focusStateEnabled]="false" [activeStateEnabled]="true" (onItemClick)="targetTreeFieldSelected.emit($event?.itemData)">

								<div *dxTemplate="let item of 'item'">
									<div class="tree-item">
										<div class="tree-main">
											<span class="tree-name">{{ item.displayName }}</span>
											<span class="tree-path" *ngIf="item.path">Result.{{ item.path }}</span>
										</div>

										<div class="chips">
											<span class="chip type" *ngIf="item.dataType">{{ item.dataType }}</span>
											<span class="chip readonly" *ngIf="item.isReadOnly">readonly</span>
											<span class="chip picklist" *ngIf="item.isPicklist">picklist</span>
											<span class="chip reference" *ngIf="item.isReference">reference</span>
											<span class="chip udf" *ngIf="item.isUserDefinedField">UDF</span>
											<span class="chip" *ngIf="item.isCollection">collection</span>
										</div>
									</div>
								</div>
							</dx-tree-view>
						</div>
					</div>
				</div>

			</div>

			<div class="popup-right toolbox-panel">
				<div class="helper-title">Toolbox</div>

				<dx-text-box [value]="expressionToolSearch" (valueChange)="expressionToolSearchChange.emit($event)" placeholder="Search functions, operators, snippets...">
				</dx-text-box>

				<div class="tool-category-tabs">
					<div class="tool-category-tab" [class.active]="selectedExpressionToolCategory === category" *ngFor="let category of expressionToolCategories" (click)="selectedExpressionToolCategoryChange.emit(category)">
						{{ category === 'NullConditional' ? 'Null / Conditional' : category === 'DateTime' ? 'Date / Time' : category === 'CollectionAggregate' ? 'Collection / Aggregate' : category }}
					</div>
				</div>

				<div class="tool-groups" *ngIf="groupedExpressionTools.length > 0; else noTools">
					<div class="tool-group" *ngFor="let group of groupedExpressionTools">
						<div class="tool-group-title">{{ group.category }}</div>

						<div class="tool-item" *ngFor="let tool of group.items" (mousedown)="$event.preventDefault(); insertTool.emit(tool)">
							<div class="tool-item-header">
								<span class="tool-item-label">{{ tool.label }}</span>
								<span class="chip type">{{ tool.backendDefined ? 'backend' : tool.kind }}</span>
							</div>

							<div class="tool-item-template">{{ tool.template }}</div>
							<div class="tool-item-description">{{ tool.description }}</div>

							<div class="tool-doc-popover" *ngIf="tool.backendDefined" (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
								<div class="tool-doc-title">{{ tool.label }}</div>
								<div class="tool-doc-section" *ngIf="tool.usage">
									<span>How to use</span>
									<code>{{ tool.usage }}</code>
								</div>
								<div class="tool-doc-section">
									<span>What it does</span>
									<p>{{ tool.description }}</p>
								</div>
								<div class="tool-doc-section" *ngIf="tool.example">
									<span>Example</span>
									<code>{{ tool.example }}</code>
								</div>
								<div class="tool-doc-section" *ngIf="tool.exampleResult">
									<span>Result</span>
									<code>{{ tool.exampleResult }}</code>
								</div>
								<div class="tool-doc-note" *ngIf="tool.notes">{{ tool.notes }}</div>
							</div>
						</div>
					</div>
				</div>

				<ng-template #noTools>
					<div class="empty-hint">No tools found.</div>
				</ng-template>
			</div>
			</div>

			<footer class="popup-footer">
				<span>Fields and tools are inserted at the current cursor position.</span>
				<div class="popup-footer-actions">
					<dx-button text="Cancel" type="normal" stylingMode="text" (onClick)="cancel.emit()"></dx-button>
					<dx-button text="Apply expression" type="default" stylingMode="contained" [elementAttr]="applyExpressionButtonElementAttr" (onClick)="apply.emit()"></dx-button>
				</div>
			</footer>
		</div>
	</div>
</dx-popup>
